import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../../dialog-feed/models/DialogState';

export const ADD_COMMENT = 'ADD_COMMENT';

export class AddCommentAction implements IDialogAction {
    public readonly type = ADD_COMMENT;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(): any {
        if(this._service) {
            this._service.addComment(this.payload.parentIds, this.payload.text);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        return state;
    }
}